import { render, staticRenderFns } from "./video-element.vue?vue&type=template&id=d084ad52&scoped=true&"
import script from "./video-element.vue?vue&type=script&lang=js&"
export * from "./video-element.vue?vue&type=script&lang=js&"
import style0 from "./video-element.vue?vue&type=style&index=0&id=d084ad52&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d084ad52",
  null
  
)

export default component.exports